/**
 * External dependencies
 */
import { ImageUploadPlaceholder } from '~cartzillagb/components'
import classnames from 'classnames'
import { range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'

const save = props => {
	const { 
		attributes, 
		className,
	} = props

	const {
		blockId,
		postsToShow,
		postperslide,
		slidesToScroll,
		displayAuthorImage,
		displayAuthorName,
		displayReviewDate,
		enableContainer,
		displaySectionHeader,
		displayStarRatings,
		heading,
		backgroundColor,
		background,
		design,
		displayboxShadow,

		// Carousel
		arrows,
	} = attributes

	const mainClasses = classnames( [
		className,
		( design ==='style-1' && background !== undefined ) ? background : ( design ==='style-1' && 'bg-secondary' ),
		( design ==='style-2' && background !== undefined ) ? background : ( design ==='style-2' && 'bg-light' ),
	], applyFilters( 'cartzillagb.review-carousel.main-block.classes', {
		'pt-5 pb-300': design === 'style-1',
		'py-5 rounded-lg my-5 px-3 px-sm-4' : design === 'style-2',
	}, props ) )

	const containerClasses = classnames( [
		' py-md-5 mb-4 pt-3 pb-4',
		enableContainer ? 'container' : '',
	] )

	const cardClasses = classnames( [
		' card border-0',
		displayboxShadow ? 'box-shadow-sm' : '',
	] )

	const styleAttr = {}

	styleAttr.style = {
		backgroundColor: backgroundColor && backgroundColor,
	}

	let headingclass = 'text-center '

	if (design === 'style-1') {
		headingclass='mb-4 mb-md-5 pb-2'
	}
	if (design === 'style-2') {
		headingclass='h3 py-4'
	}

	const headingComp = (
		<RichText.Content
			tagName='h2'
			className={ headingclass }
			value={ heading || 'Customer reviews' }
		/>
	)

	const content = range( 1, ( postsToShow ) + 1 ).map( i => {

		const review = attributes[ `review${ i }` ]
		const AuthorImage = attributes[ `authorImage${ i }` ]
		const AuthorName = attributes[ `authorname${ i }` ]
		const ReviewDate = attributes[ `reviewdate${ i }` ]

		let defaultauthorname = ''
		let defaultdate = ''

		if ( (i % 6 ) === 1 ) {
			defaultauthorname = __( 'Richard Davis', i18n )
			defaultdate =' Feb 14, 2020'
		}

		if ( (i % 6 ) === 2 ) {
			defaultauthorname = __( 'Laura Willson', i18n )
			defaultdate = "Feb 05, 2020"
		}

		if ( (i % 6 ) === 3 ) {
			defaultauthorname = __( 'Mary Alice Grant', i18n )
			defaultdate = 'Feb 14, 2020'
		}
		if ( (i % 6 ) === 4 ) {
			defaultauthorname = __( 'Rafael Marquez', i18n )
			defaultdate = 'Feb 14, 2020'
		}
		if ( (i % 6 ) === 5 ) {
			defaultauthorname = __( 'Adrian Lewis', i18n )
			defaultdate = 'Feb 14, 2020'
		}
		if ( (i % 6 ) === 0 ) {
			defaultauthorname = __( 'Daniel Adams', i18n )
			defaultdate = 'Feb 14, 2020'
		}


		const reviewComp = (
			<RichText.Content
				value={ review || 'Lorem ipsum dolor sit amet, quia non consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' }
			/>
		)

		const authornameComp = (
			<RichText.Content
				tagName='h6'
				className='font-size-sm mb-n1'
				value={ AuthorName || defaultauthorname }
			/>
		)

		const reviewdateComp = (
			<RichText.Content
				tagName='span'
				className='font-size-ms text-muted opacity-75'
				value={ ReviewDate || defaultdate }
			/>
		)

		const imageComp = (
			<ImageUploadPlaceholder
				imageURL={ AuthorImage }
				render={ 
					<img 
						src={ AuthorImage }
						width="50"
						className="rounded-circle"
						alt={ __( 'Author', i18n ) } 
					/> 
				}
			/>
		)

		{ console.log(AuthorImage)}

		const output = (
			<blockquote className="mb-2" key={ i }>
				<div className={ cardClasses }><span className="cz-testimonial-mark"></span>
					<div className="card-body font-size-md text-muted">
						<div className="mb-2">
							{ displayStarRatings &&
								<div className="star-rating">
									{ range( 1, 6 ).map( j => {

										let activeClass = ''

										if ( j <= attributes[ `starRatings${ i }` ] ) {
											activeClass = "-filled active"
										}

										return (
											<i className={ `sr-star czi-star${ activeClass }` } key={ j }></i>
										);
									} ) }
								</div>
							}
						</div>
						{ reviewComp }
					</div>
				</div>
				<footer className="d-flex justify-content-center pt-4">
					<div className="media align-items-center">
						{ displayAuthorImage && 
							imageComp
						}
						<div className="media-body pl-3">
							{ displayAuthorName &&
								authornameComp
							}
							{ displayReviewDate &&
								reviewdateComp
							}
						</div>
					</div>
				</footer>
			</blockquote>
		)
			
		return output
	} )


	const defaultCarouselOptions = applyFilters( 'cartzillagb.review-carousel.main-block.classes', {
		slidesToShow: 5,
		slidesToScroll: 5,
		dots: true,
		arrows: true,
		adaptiveHeight: true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		customArrows: '.cz-custom-controls',
		speed: 500,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
	}, props )

	let carouselOptions = {
		slidesToShow: postperslide,
		slidesToScroll: slidesToScroll,
		dots: true,
		arrows: true,
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
		'mb-3',
		arrows && 'cz-controls-outside',
	] )

		
	return (
		<Fragment>
			{ design === 'style-1' &&
				<section id={ blockId } className={ mainClasses } { ...styleAttr }>
					<div className={ containerClasses }>
						<Fragment>
							{ displaySectionHeader &&
								headingComp
							}
						  	<div { ...wraperAttr }>
								<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
									{ content }
								</div>
							</div>
						</Fragment>
					</div>
				</section>
			}
			{ design === 'style-2' &&
				<section id={ blockId } className={ mainClasses } { ...styleAttr }>
						<Fragment>
							{ displaySectionHeader &&
								headingComp
							}
						  	<div { ...wraperAttr }>
								<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
									{ content }
								</div>
							</div>
						</Fragment>
				</section>
			}
		</Fragment>
	)
}

export default save